import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {SocialLoginState} from './SocialLoginState';
import msLogo from '../../assets/images/ms-symbollockup_signin_dark.svg';
import {useMsal} from '@azure/msal-react';
import {showCommunicationError} from '../../helpers/alerts';
import {GoogleLogin} from '@react-oauth/google';
import {NO_AUTOLOGIN_QUERY_PARAM} from '../../AppMainState';

export interface SocialLoginProps {
    state: SocialLoginState;
    title?: string;
    register?: boolean;
}


export const SocialLogin: FunctionComponent<SocialLoginProps> = observer(({title, state, register}) => {
    const msal = useMsal();

    const urlParams = new URLSearchParams(window.location.search);
    const noAutologinParam = urlParams.get(NO_AUTOLOGIN_QUERY_PARAM);

    const autologin = !(register || noAutologinParam);

    return <React.Fragment>
        <button
            style={{backgroundColor: '#2f2f2f', height: 42}}
            className="mt-4 w-full mb-4"
            type="button"
            onClick={() => state.signInWithMicrosoft(msal, register)}>
            <img
                className="inline-block "

                src={msLogo}
                alt="Sign in with Microsoft"
            />
        </button>

        <GoogleLogin
            size={'large'}
            auto_select={autologin}
            theme={'filled_black'}
            useOneTap={autologin}
            onSuccess={credentialResponse => {
                state.signInWithGoogle(credentialResponse);
            }}
            onError={() => {
                showCommunicationError('Error when logging, please report us at email support@muscula.com');
            }}
        />
    </React.Fragment>;
});
